<template>
    <div style="display:inline-flex">
        <a-date-picker :default-value="moment(startDate, dateFormat)" class="timePicker" v-if="dataType == 'day'" placeholder="选择日期"  @change="handleTimeChange" />

        <a-week-picker :default-value="moment(startDate, dateFormat)"  class="timePicker" v-if="dataType == 'week'" placeholder="选择星期" @change="handleTimeChange" />

        <a-month-picker  :default-value="moment(startDate, dateFormat)" class="timePicker" v-if="dataType == 'month'" placeholder="选择月份" @change="handleTimeChange" />
    </div>

</template>
<script>


export default {
    data() {
        return {
            result:{
                startDate:'',
                endDate:'',
            },
            dateFormat:'YYYY/MM/DD'

        }
    },
    computed: {
       
    },
    props: {
        dataType:String,
        startDate:String,
    },
    methods: {
        handleTimeChange(date, dateString){
            if(this.dataType == 'day'){
                this.result.startDate = dateString;
                this.result.endDate = dateString;
            }
            else if(this.dataType == 'week'){
                let tempWeekDate = this.getWeekDate(date);
                this.result.startDate = tempWeekDate.start;
                this.result.endDate = tempWeekDate.end;
            }
            else if(this.dataType == 'month'){
                let tempMonthDate = this.getMonthDate(date);
                this.result.startDate = tempMonthDate.start;
                this.result.endDate = tempMonthDate.end;
            }
            this.$emit('timeChange',this.result)
        },
        getMonthDate(date){
            let now = new Date(date);
            var nowMonth = now.getMonth(); //当前月
            var nowYear = now.getYear(); //当前年
            nowYear += (nowYear < 2000) ? 1900 : 0; //
            var monthStartDate = new Date(nowYear, nowMonth, 1);
            var monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth,nowYear));
            var start_time = monthStartDate.Format('yyyy-MM-dd');
            var end_time = monthEndDate.Format('yyyy-MM-dd');
            return {
                start:start_time,
                end:end_time
            }
        },
        //获得某月的天数
        getMonthDays(myMonth,nowYear) {
            var monthStartDate = new Date(nowYear, myMonth, 1);
            var monthEndDate = new Date(nowYear, myMonth + 1, 1);
            var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            return days;
        },
        getWeekDate(date){
            let target = new Date(date);
            var nowTime = target.getTime();
            var day = target.getDay();
            if (day == 0) {
                day = 7;
            }
            var oneDayLong = 24 * 60 * 60 * 1000;
            var MondayTime = nowTime - (day - 1) * oneDayLong;
            var SundayTime = nowTime + (7 - day) * oneDayLong;

            var monday = new Date(MondayTime).Format('yyyy-MM-dd');
            var sunday = new Date(SundayTime).Format('yyyy-MM-dd');
            return {
                start:monday,
                end:sunday
            }
            
        },
    },
    mounted() {
    },
    watch: {

    }
 
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}
</style>
